import Vue from "vue";
import Toasted from "vue-toasted";
Vue.use(Toasted, Option);
// options to the toast
let options = {
  type: "error",
  theme: "toasted-primary",
  duration: 3000
};

// register the toast with the custom message
Vue.toasted.register(
  "resp_err",
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Oops.. Something Went Wrong..";
    }

    // if there is a message show it with the message
    return payload.message;
  },
  options
);
